<template>
    <v-layout justify-center>
        <v-dialog v-model="show"  width="800px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Событие</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-actions class="content">
                    <v-container fluid class="pa-0 ma-0">
                        <v-row>
                    <v-col cols="4" md4 v-for="albumVkItem in albumVkItems"
                           :key="albumVkItem.id"
                    >
                        <v-card >
                            <v-card-actions>
                                <v-container fluid class="pa-0 ma-0">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-img
                                                    class="pa-0 ma-0"
                                                    :src="albumVkItem.thumb_photo"
                                                    style="width: 50%"
                                            >
                                            </v-img>
                                        </v-col>
                                        <v-col cols="12" class="py-0 caption">
                                            <span>Название: {{albumVkItem.title}}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0 caption">
                                            <span>Id продукта: {{albumVkItem.id}}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0 caption">
                                            <span>Описание: {{albumVkItem.description}}</span>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'ToolMarketAlbumVkViewer',
    props: ['dialog'],
    data() {
        return {
            show: false
        }
    },
    watch: {
        dialog(value) {
            if (value === true) {
                this.show = true
            }
        },
        show(value) {
            if (value === false) {
                this.$emit('close')
            }
        }
    },
    computed: {
        ...mapGetters({
            albumVkItems: 'tools/albumVkItems'
        })
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
